// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"1d152e09","842":"6c4d3f3d"}[chunkId] + ".chunk.js";
};